<script setup lang="ts">
import HomeLayout from "~/layouts/HomeLayout.vue"
import { SUPPORTED_PAGES_ENUM } from "~/common/breadCrumbs"

/**
 *
 *  Props and emits section
 *
 *
 */

useSeoMeta({
    title: '¿Quiénes somos?',
    ogTitle: '¿Quiénes somos? - Dapamas',
})

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
</script>

<template>
    <HomeLayout
        title="¿Quiénes somos?"
        :currentPage="SUPPORTED_PAGES_ENUM.AboutUs"
        withoutSteps
    >
        <div class="tw-flex tw-flex-col tw-gap-4">
            <p class="tw-text-xl tw-leading-7 tw-text-customGray-500">
                En
                <NuxtLink
                    :to="SUPPORTED_PAGES_ENUM.Home"
                    class="tw-text-primary"
                    >dapamás.com</NuxtLink
                >, somos una plataforma digital dedicada a conectar a
                compradores y vendedores de manera simple, segura y eficiente.
                Nuestro objetivo es ofrecer una experiencia de compra única,
                brindando acceso a una amplia variedad de productos y servicios
                de calidad, todo en un solo lugar.
            </p>
            <p
                class="tw-text-xl tw-leading-7 tw-text-customGray-500 tw-font-bold"
            >
                Nuestra misión
            </p>
            <p class="tw-text-xl tw-leading-7 tw-text-customGray-500">
                Facilitar el comercio entre personas y empresas, ofreciendo una
                plataforma intuitiva y confiable donde puedan descubrir, comprar
                y vender productos de todo tipo. Buscamos simplificar el proceso
                de compra en línea, proporcionando opciones variadas y una
                experiencia de usuario excepcional.
            </p>
            <p
                class="tw-text-xl tw-leading-7 tw-text-customGray-500 tw-font-bold"
            >
                Lo que nos hace diferentes
            </p>
            <p class="tw-text-xl tw-leading-7 tw-text-customGray-500">
                Lo que nos distingue es nuestra capacidad para reunir a diversos
                vendedores y marcas bajo un mismo techo digital, permitiendo a
                los consumidores acceder a una oferta más amplia y diversa. Nos
                aseguramos de que cada transacción sea segura, transparente y
                satisfactoria para todas las partes involucradas.
            </p>
            <p
                class="tw-text-xl tw-leading-7 tw-text-customGray-500 tw-font-bold"
            >
                Para los compradores
            </p>
            <p class="tw-text-xl tw-leading-7 tw-text-customGray-500">
                Ofrecemos una plataforma fácil de usar, con filtros de búsqueda,
                valoraciones y reseñas de otros usuarios, y múltiples opciones
                de pago. Nuestra prioridad es que encuentres lo que buscas de
                manera rápida, confiable y conveniente.
            </p>
            <p
                class="tw-text-xl tw-leading-7 tw-text-customGray-500 tw-font-bold"
            >
                Para los vendedores
            </p>
            <p class="tw-text-xl tw-leading-7 tw-text-customGray-500">
                Brindamos una solución integral que facilita la venta de
                productos y servicios a través de un sistema de gestión simple y
                eficiente. Desde la carga de inventarios hasta el procesamiento
                de pagos, nuestra plataforma está diseñada para ayudarte a
                crecer, alcanzar nuevos clientes y optimizar tus ventas.
            </p>
            <p
                class="tw-text-xl tw-leading-7 tw-text-customGray-500 tw-font-bold"
            >
                Nuestros valores
            </p>
            <ul class="tw-text-xl tw-leading-7 tw-text-customGray-500">
                <li>
                    <span class="tw-font-semibold">Confianza:</span>
                    Garantizamos un entorno seguro para todas las transacciones.
                </li>
                <li>
                    <span class="tw-font-semibold">Variedad:</span> Una oferta
                    amplia y diversa de productos de distintos vendedores.
                </li>
                <li>
                    <span class="tw-font-semibold">Compromiso:</span> Trabajamos
                    para mejorar continuamente la experiencia de todos nuestros
                    usuarios.
                </li>
                <li>
                    <span class="tw-font-semibold">Transparencia:</span> Creemos
                    en la honestidad y la claridad, tanto para compradores como
                    para vendedores.
                </li>
            </ul>
            <p
                class="tw-text-xl tw-leading-7 tw-text-customGray-500 tw-font-bold"
            >
                Únete a nosotros
            </p>
            <p class="tw-text-xl tw-leading-7 tw-text-customGray-500">
                Si eres un comprador en busca de calidad y variedad, o un
                vendedor que desea llegar a más clientes, en dapamás.com tenemos
                un espacio para ti. ¡Bienvenido a la comunidad!
            </p>
        </div>
    </HomeLayout>
</template>

<style scoped></style>
